/**
 * HENNE Wunschliste — Speicher, Herz-Buttons, Zähler im Kopfbereich.
 *
 * Die alte Fassung hat beim Merken Titel, Bild und Preis mitgespeichert und
 * auf der Wunschlistenseite genau diese Kopie angezeigt. Folge: Preise aus
 * dem Moment des Merkens, auch wenn der Artikel längst reduziert oder teurer
 * war; ausverkaufte Artikel sahen aus wie lieferbar. Eine veraltete Preis-
 * angabe im Shop ist mehr als ein Schönheitsfehler.
 *
 * Jetzt wird nur noch festgehalten, WAS gemerkt wurde (Handle, Produkt-ID)
 * und zu welchem Preis — Letzteres nur, um auf der Wunschlistenseite einen
 * gesunkenen Preis anzeigen zu können. Alles, was angezeigt wird, lädt die
 * Seite frisch aus dem Shop.
 *
 * Gespeichert wird im Browser (localStorage), wie bisher. Bestehende Listen
 * im alten Format werden beim ersten Laden übernommen.
 */

(function () {
  'use strict';

  const SCHLUESSEL = 'henne_wishlist';
  const VERSION = 2;

  function lesen() {
    try {
      const roh = JSON.parse(localStorage.getItem(SCHLUESSEL) || '[]');
      if (!Array.isArray(roh)) return [];
      // Altes Format: {id, handle, title, url, image, price, compareAtPrice, addedAt}
      return roh
        .filter((e) => e && (e.handle || e.url))
        .map((e) => ({
          handle: e.handle || String(e.url || '').split('/products/')[1]?.split(/[?#/]/)[0] || '',
          id: e.id ? String(e.id) : '',
          preisBeimMerken: e.preisBeimMerken != null ? Number(e.preisBeimMerken) : (e.price != null ? Number(e.price) : null),
          gemerktAm: e.gemerktAm || e.addedAt || new Date().toISOString(),
          v: VERSION,
        }))
        .filter((e) => e.handle);
    } catch (_) {
      return [];
    }
  }

  function schreiben(liste) {
    try {
      localStorage.setItem(SCHLUESSEL, JSON.stringify(liste));
    } catch (_) {
      /* privater Modus o. Ä. — die Liste lebt dann nur bis zum Neuladen */
    }
    document.dispatchEvent(new CustomEvent('wishlistUpdated', { detail: { anzahl: liste.length } }));
  }

  const Wunschliste = {
    liste: lesen(),

    alle() {
      return this.liste.slice();
    },

    enthaelt(handleOderId) {
      const k = String(handleOderId);
      return this.liste.some((e) => e.handle === k || e.id === k);
    },

    hinzufuegen({ handle, id, preis }) {
      if (!handle || this.enthaelt(handle)) return false;
      this.liste.unshift({
        handle,
        id: id ? String(id) : '',
        preisBeimMerken: preis != null && preis !== '' ? Number(preis) : null,
        gemerktAm: new Date().toISOString(),
        v: VERSION,
      });
      schreiben(this.liste);
      return true;
    },

    entfernen(handleOderId) {
      const k = String(handleOderId);
      const vorher = this.liste.length;
      this.liste = this.liste.filter((e) => e.handle !== k && e.id !== k);
      if (this.liste.length !== vorher) schreiben(this.liste);
      return this.liste.length !== vorher;
    },

    ersetzen(liste) {
      this.liste = liste;
      schreiben(this.liste);
    },

    leeren() {
      this.liste = [];
      schreiben(this.liste);
    },
  };

  // Andere Tabs: Liste neu lesen, wenn sie dort geändert wurde.
  window.addEventListener('storage', (e) => {
    if (e.key !== SCHLUESSEL) return;
    Wunschliste.liste = lesen();
    document.dispatchEvent(new CustomEvent('wishlistUpdated', { detail: { anzahl: Wunschliste.liste.length } }));
  });

  // ---------------------------------------------------------------------------
  // Herz-Buttons
  // ---------------------------------------------------------------------------

  const de = (document.documentElement.lang || 'de').toLowerCase().startsWith('de');
  const T = de
    ? { merken: 'Auf die Wunschliste', entfernen: 'Von der Wunschliste nehmen', gemerkt: 'Auf deiner Wunschliste', entfernt: 'Von der Wunschliste genommen', ansehen: 'Ansehen' }
    : { merken: 'Add to wishlist', entfernen: 'Remove from wishlist', gemerkt: 'Saved to your wishlist', entfernt: 'Removed from wishlist', ansehen: 'View' };

  // Nur schreiben, was sich wirklich ändert. Ein textContent-Zuweisen
  // ersetzt den Textknoten — das zählt für den MutationObserver unten als
  // neu eingefügter Knoten und hat in der ersten Fassung eine Endlosschleife
  // ausgelöst, die jede Seite mit Herzen eingefroren hat.
  function setze(el, attr, wert) {
    if (el.getAttribute(attr) !== wert) el.setAttribute(attr, wert);
  }
  function knopfZustand(knopf) {
    const an = Wunschliste.enthaelt(knopf.dataset.productHandle || knopf.dataset.productId);
    if (knopf.classList.contains('wishlist-button--active') !== an) knopf.classList.toggle('wishlist-button--active', an);
    setze(knopf, 'aria-pressed', an ? 'true' : 'false');
    setze(knopf, 'aria-label', an ? T.entfernen : T.merken);
    setze(knopf, 'title', an ? T.entfernen : T.merken);
    const leer = knopf.querySelector('.wishlist-icon--empty');
    const voll = knopf.querySelector('.wishlist-icon--filled');
    if (leer && leer.style.display !== (an ? 'none' : 'block')) leer.style.display = an ? 'none' : 'block';
    if (voll && voll.style.display !== (an ? 'block' : 'none')) voll.style.display = an ? 'block' : 'none';
    const text = knopf.querySelector('.visually-hidden');
    const soll = an ? T.entfernen : T.merken;
    if (text && text.textContent !== soll) text.textContent = soll;
  }

  function alleKnoepfe() {
    document.querySelectorAll('.wishlist-button').forEach(knopfZustand);
  }

  function zaehler() {
    const n = Wunschliste.liste.length;
    const soll = n > 0 ? String(n) : '';
    document.querySelectorAll('.wishlist-count').forEach((el) => {
      if (el.textContent !== soll) el.textContent = soll;
      if (el.hidden !== (n === 0)) el.hidden = n === 0;
      const anzeige = n > 0 ? '' : 'none';
      if (el.style.display !== anzeige) el.style.display = anzeige;
    });
    document.querySelectorAll('.wishlist-header-link').forEach((a) => {
      a.setAttribute('aria-label', n > 0 ? `${de ? 'Wunschliste' : 'Wishlist'}, ${n} ${de ? (n === 1 ? 'Artikel' : 'Artikel') : (n === 1 ? 'item' : 'items')}` : (de ? 'Wunschliste' : 'Wishlist'));
    });
  }

  // Kurzer Hinweis unten am Bildschirmrand, mit Link zur Liste.
  let hinweisTimer = null;
  function hinweis(text, mitLink) {
    let el = document.getElementById('henne-wl-hinweis');
    if (!el) {
      el = document.createElement('div');
      el.id = 'henne-wl-hinweis';
      el.className = 'henne-wl-hinweis';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.innerHTML = '';
    const span = document.createElement('span');
    span.textContent = text;
    el.appendChild(span);
    if (mitLink) {
      const a = document.createElement('a');
      a.href = (window.Shopify?.routes?.root || '/') + 'pages/wishlist';
      a.textContent = T.ansehen;
      el.appendChild(a);
    }
    el.classList.add('henne-wl-hinweis--sichtbar');
    clearTimeout(hinweisTimer);
    hinweisTimer = setTimeout(() => el.classList.remove('henne-wl-hinweis--sichtbar'), 3200);
  }

  document.addEventListener('click', (e) => {
    const knopf = e.target.closest('.wishlist-button');
    if (!knopf) return;
    e.preventDefault();
    e.stopPropagation();
    const handle = knopf.dataset.productHandle;
    const id = knopf.dataset.productId;
    if (Wunschliste.enthaelt(handle || id)) {
      Wunschliste.entfernen(handle || id);
      hinweis(T.entfernt, false);
    } else {
      Wunschliste.hinzufuegen({ handle, id, preis: knopf.dataset.productPrice });
      hinweis(T.gemerkt, true);
    }
  });

  document.addEventListener('wishlistUpdated', () => {
    alleKnoepfe();
    zaehler();
  });

  function start() {
    // Altes Format sofort ins neue überführen, damit es nur einmal passiert.
    if (Wunschliste.liste.some((e) => e.v !== VERSION)) schreiben(Wunschliste.liste);
    alleKnoepfe();
    zaehler();
    // Produktkarten, die nachgeladen werden (Filter, Endlosliste), mitnehmen.
    // Nur auf neue Knöpfe reagieren, nie auf Änderungen in einem Knopf selbst,
    // und höchstens einmal pro Bild.
    let geplant = false;
    new MutationObserver((m) => {
      if (geplant) return;
      const neueKnoepfe = m.some((x) => {
        if (x.target.closest && x.target.closest('.wishlist-button')) return false;
        return [...x.addedNodes].some((n) => n.nodeType === 1 && (n.matches?.('.wishlist-button') || n.querySelector?.('.wishlist-button')));
      });
      if (!neueKnoepfe) return;
      geplant = true;
      requestAnimationFrame(() => { geplant = false; alleKnoepfe(); });
    }).observe(document.body, { childList: true, subtree: true });

    // Das Theme baut den Kopfbereich nach dem Laden per morph.js neu auf und
    // schreibt dabei den Zähler auf den Stand aus dem Server-HTML zurück.
    // Deshalb den Zähler selbst beobachten und bei Abweichung neu setzen.
    // zaehler() schreibt nur bei Abweichung, also keine Schleife.
    let zGeplant = false;
    new MutationObserver((m) => {
      if (zGeplant) return;
      const betrifft = m.some((x) => {
        const t = x.target.nodeType === 1 ? x.target : x.target.parentElement;
        if (t && t.closest && t.closest('.wishlist-count')) return true;
        return [...x.addedNodes].some((n) => n.nodeType === 1 && (n.matches?.('.wishlist-count') || n.querySelector?.('.wishlist-count')));
      });
      if (!betrifft) return;
      zGeplant = true;
      requestAnimationFrame(() => { zGeplant = false; zaehler(); });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.HenneWunschliste = Wunschliste;

  // Die alte Schnittstelle bleibt erreichbar, falls noch etwas darauf zugreift.
  window.WishlistManager = {
    getWishlist: () => Wunschliste.alle(),
    isInWishlist: (k) => Wunschliste.enthaelt(k),
    removeProduct: (k) => Wunschliste.entfernen(k),
    clearWishlist: () => Wunschliste.leeren(),
    updateAllButtons: alleKnoepfe,
    updateWishlistCount: zaehler,
  };
})();
